<template>
    <div>
        <h1 class="regisTitulo">{{vista}}</h1>  
        <div v-if=" atras!=false" @click="back()" class="colorback">
            <b-icon icon="arrow-left-circle"></b-icon>
            Atrás
        </div>
            <b-breadcrumb>
            <b-breadcrumb-item :active=" atras==false" :href="url">
            Inicio
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if=" atras!=false" active>{{carpeta + ruta }}</b-breadcrumb-item>
        </b-breadcrumb>
    </div>
</template>
<script>
import Vue from 'vue';
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";
  
export default {
name: "HeaderGeneral",
components: {},

props: [
  "vista",
  "ruta" ,
  "carpeta",
  "atras"
],
data() {
      return {
       url:"/inicio",
      }},
      methods:{
        back(){
            this.$router.go(-1)
        },}
 
  

};
</script>
<style>
.regisTitulo {
    font-size: 30px !important;
    text-align: left!important;
    font-weight: 600 !important;
    color: var(--blue-violet);
}
.colorback {
    color: var(--blue-violet);
    font-weight: 800;
    cursor: pointer;
    position: absolute;
    right: 6%;
    top: 17%;
}
</style>